<template>
  <LoadingOverlay v-if="routeLoading" />

  <div class="min-h-screen bg-white">
    <div v-if="showMissingNiNumberBanner" class="bg-yellow-50 p-3 ring-1 ring-yellow-600/20">
      <h3 class="text-xs font-medium text-yellow-800">
        Please confirm if these details are still up to date.
        <NuxtLink class="underline" to="/profile/update">Click here</NuxtLink>
        to confirm.
      </h3>
    </div>

    <div v-if="showRightToWorkBanner" class="flex items-start gap-3 bg-yellow-50 p-3 ring-1 ring-yellow-600/20">
      <h3 class="flex-1 text-xs font-medium text-yellow-800">
        Please be advised that you do not need to upload any documents in the Proof of Right to Work section on your
        dashboard. Your local team will assist you with this when you next visit your local hub.
      </h3>
      <button
        type="button"
        class="inline-flex flex-shrink-0 rounded-md text-yellow-700 hover:text-yellow-900 focus:outline-none"
        data-cy="dismiss-right-to-work-banner"
        @click="dismissRightToWorkBanner"
      >
        <span class="sr-only">Dismiss</span>
        <XMarkIcon class="h-4 w-4" aria-hidden="true" />
      </button>
    </div>

    <slot />
  </div>

  <Footer />
</template>

<script setup>
import { XMarkIcon } from '@heroicons/vue/20/solid'

const nuxtApp = useNuxtApp()
const routeLoading = ref()
const user = useUser()

const showMissingNiNumberBanner = computed(() => {
  const driver = user.value?.driver

  if (!driver || driver.fleet?.show_ni_banner !== true || !Object.hasOwn(driver, 'ni_number')) {
    return false
  }

  const niNumber = driver.ni_number

  return niNumber === null || (typeof niNumber === 'string' && niNumber.trim() === '')
})

const rightToWorkBannerFleetCodes = ['VM', 'VN', 'FVL']
const sessionStorage = useSessionStorage()
const rightToWorkBannerDismissed = ref(sessionStorage.getItem('right_to_work_banner_dismissed') === true)

function dismissRightToWorkBanner() {
  rightToWorkBannerDismissed.value = true
  sessionStorage.setItem('right_to_work_banner_dismissed', true)
}

const showRightToWorkBanner = computed(() => {
  if (rightToWorkBannerDismissed.value) {
    return false
  }

  const fleetName = user.value?.driver?.fleet?.name

  if (typeof fleetName !== 'string') {
    return false
  }

  const fleetCode = fleetName.trim().match(/\(([A-Z]+)\)$/)?.[1]

  return fleetCode !== undefined && rightToWorkBannerFleetCodes.includes(fleetCode)
})

nuxtApp.hooks.hook('page:loading:start', () => {
  routeLoading.value = true
})

nuxtApp.hooks.hook('page:loading:end', () => {
  routeLoading.value = false
})
</script>
